import { render, staticRenderFns } from "./ModalPasswordRecovery.vue?vue&type=template&id=2896ff12&"
import script from "./ModalPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./ModalPasswordRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports